import React from 'react'
import { useDispatch } from 'react-redux'
import { FormSection } from '../../../../../core/components/FormSection.tsx'
import { InputManager } from '../../../../../core/components/InputManager/index.ts'
import { useLookups } from '../../../../global_configs/hooks/useLookups.ts'
import { updateProspectRecord } from '../../../../../state_manager/state_update_actions/fundraising/index.ts'
import { ProspectFields } from '../../../utils/fieldConfigs.ts'
import { getInvestorFields } from '../../../utils/fieldConfigs.ts'
import { updateProspectRecord as updateProspectRecordAction } from '../../../../../state_manager/state_update_actions/fundraising/index.ts'

export function InvestorSection({
  formData,
  handleFieldChange,
  onPatchSuccess,
  isReadOnly = false,
  recordId = null,
  cardProps = {},
  investorId = null
}: {
  formData?: any
  handleFieldChange?: (field: string, value: any) => void
  onPatchSuccess?: (patchRecordId: string, updates: Record<string, any>) => void
  isReadOnly?: boolean
  recordId?: string | null
  cardProps?: Record<string, any>
  investorId?: string | null
}) {
  const { getLookupOptions } = useLookups()
  const dispatch = useDispatch()

  const data = formData || {}

  const accountId = investorId || data[ProspectFields.prospects__investor] || null

  const fieldOptions = {
    getLookupOptions
  }

  const prospectId = recordId || data[ProspectFields.prospects__id] || data.id

  const handlePatchSuccessLocal = (patchRecordId: string, updates: Record<string, any>) => {
    if (updates.prospects__notes !== undefined || updates.notes !== undefined) {
      const notesProspectId = updates.id || prospectId
      if (notesProspectId && onPatchSuccess) {
        onPatchSuccess(notesProspectId, updates)
      } else if (notesProspectId) {
        dispatch(updateProspectRecordAction({ prospectId: notesProspectId, updates }))
      }
    } else {
      const accountUpdateId = updates.id || patchRecordId
      if (onPatchSuccess) {
        onPatchSuccess(accountUpdateId, updates)
      }
    }
  }

  return (
    <FormSection
      data-debug='investor-section'
      data-component='InvestorSection'
      title='Investor'
      titleColor='blue'
      {...cardProps}
    >
      <div data-debug='investor-section-content'>
        <InputManager
          inputMode='read'
          labelPosition='inline'
          fields={getInvestorFields(data, fieldOptions, isReadOnly)}
          onChange={(key, value) => {
            handleFieldChange?.(key, value)
          }}
          enableAutoPatch={!isReadOnly && (!!accountId || !!prospectId)}
          patchId={prospectId || accountId}
          recordId={prospectId || accountId}
          onPatchSuccess={handlePatchSuccessLocal}
          className='investor-section-fields'
        />
      </div>
    </FormSection>
  )
}
